
  Vue.component('highlights-show-button', {
    props: {
      showOnOver: { type: Boolean, default: false },
      curriculumId: { type: Number, default: 0 },
      highlights: { type: Object },
      direction: { type: String, default: 'left' },
      isFixed: { type: Boolean, default: false },
      searchTerms: { type: Array, default: () => [] },
      searchParams: { type: Array, default: () => [] }
    },
    pinia: Vue.pinia,
    data() {
      return {
        clickX: 0,
        clickY: 0,
        value: '',
        descDictionary: {
          'CurriculumProfessionalSkills.CommonSkillTypeLabel': 'Competenze professionali',
          'CurriculumOtherSkills.CommonSkillTypeLabel': 'Competenze generiche',
          'CurriculumWorkExperiences.Description': 'Esperienze lavorative (Descrizione)',
          'CurriculumWorkExperiences.WorkFunctionLabel': 'Esperienze lavorative (Ruolo)',
          'CurriculumWorkExperiences.WorkFunctionLabel.keyword': 'Esperienze lavorative (Keyword)',
          'CurriculumTrainings.TrainingLabel': 'Corsi di formazione',
          'CurriculumTrainings.Description': 'Corsi di formazione (Descrizione)',
          CurrentWorkPosition: 'Posizione corrente',
          ExtractedText: 'Testo estratto  dal curriculum',
          PersonalDescription: 'Descrizione personale',
          DesiredWorkPosition: 'Posizione lavorativa desiderata',
          CurriculumLanguages: 'Lingue'
        }
      }
    },
    template: '#highlights-show-button',
    computed: {
      ...Pinia.mapState(useCurriculumHighlightsStore, {
        openHighlights: store => store.openHighlights || []
      }),
      showHighlights() {
        return this.openHighlights.includes(this.curriculumId)
      },
      highlightsItemsFound() {
        const regex = /<b>(.*?)<\/b>/g
        let count = 0
        this.arrayHighlights.forEach(item => {
          item.value.forEach(value => {
            const matches = value.replace(/\n/g, ' ').match(regex)
            if (matches) {
              count += matches.length
            }
          })
        })
        return count
      },
      fixedStyle() {
        return {
          position: 'fixed',
          left: `${this.clickX + 600}px`,
          top: `${this.clickY - 10}px`
        }
      },
      dropdownDirectionClass() {
        return `drop${this.direction}`
      },
      arrayHighlights() {
        const result = this.highlights
          ? Object.entries(this.highlights)
              .map(([key, value]) => this.highlightCustomRenderer({ key, value }))
              .sort((a, b) => a.key.localeCompare(b.key))
          : []
        return result
      }
    },
    watch: {},
    methods: {
      ...Pinia.mapActions(useCurriculumHighlightsStore, ['showHighlightsOverlay', 'hideHighlightsOverlay']),
      highlightCustomRenderer({ key, value }) {
        let retVal = { key, value }
        if (key === 'CurriculumLanguages') {
          const regex = /"IdiomLabel":"(.*?)"/g
          const idiomLabels = []
          let match
          while ((match = regex.exec(value)) !== null) {
            idiomLabels.push(match[1])
          }
          retVal = { key, value: idiomLabels }
        }
        return retVal
      },
      showHighlightsOnOver(event) {
        if (this.showOnOver && !this.showHighlights) {
          if (event) {
            const rect = event.target.getBoundingClientRect()
            this.clickX = rect.right
            this.clickY = rect.top
          }
          this.showHighlights = true
        }
      },
      hideHighlightsOnOver(event) {
        if (this.showOnOver) {
          this.showHighlights = false
        }
      },
      toggleHighlights(event) {
        if (event) {
          const rect = event.target.getBoundingClientRect()
          this.clickX = rect.right
          this.clickY = rect.top
        }
        // this.showHighlights = !this.showHighlights

        if (this.showHighlights) this.hideHighlightsOverlay(this.curriculumId)
        else this.showHighlightsOverlay(this.curriculumId)
      },
      selectHighlights(index) {
        this.selectedHighlights = index
      },
      saveHighlights(id, curriculumId, text, style, title) {
        this.saveUpdateHighlights(id, curriculumId, text, style, title)
      },
      uniqueKey(id) {
        return `${this.curriculumId}${id}${moment().format('HHmmss')}`
      },
      isEven(index) {
        return index % 2 === 0
      },
      translate(key) {
        return this.descDictionary?.[key] ?? key
      },
      checkIfScrollable() {
        const { content } = this.$refs
        const isScrollable = content.scrollHeight > content.clientHeight || content.scrollWidth > content.clientWidth

        return isScrollable
      },
      handleScroll(event) {
        if (!this.checkIfScrollable()) {
          event.preventDefault()
        }
      },
      checkSinonims(item) {
        return item
          .replace(/\n/g, ' ')
          .replace(/<b>(.*?)<\/b>/gi, (match, p1) =>
            this.searchTerms.some(value => p1.toLowerCase().startsWith(value.toLowerCase())) ? `<i>${p1}</i>` : match
          )
      }
    },
    mounted() {}
  })
